// Collection of funny error-related GIFs
export const ERROR_GIFS = [
  {
    url: 'https://media.giphy.com/media/xTiN0L7EW5trfOvEk0/giphy.gif',
    alt: 'Confused computer'
  },
  {
    url: 'https://media.giphy.com/media/8L0Pky6C83SzkzU55a/giphy.gif',
    alt: 'Surprised cat'
  },
  {
    url: 'https://media.giphy.com/media/9J7tdYltWyXIY/giphy.gif',
    alt: 'Internet explorer crying'
  },
  {
    url: 'https://media.giphy.com/media/nVTa8D8zJUc2A/giphy.gif',
    alt: 'Frustrated computer user'
  },
  {
    url: 'https://media.giphy.com/media/YyKPbc5OOTSQE/giphy.gif',
    alt: 'Turning it off and on again'
  },
  {
    url: 'https://media.giphy.com/media/llKJGxQ1ESmac/giphy.gif',
    alt: 'Monkey typing'
  }
];
